import React, { useState } from 'react';
import { recipes } from '../services/api';
import '../styles/MadeButton.css';

const MadeButton = ({ recipeId, initialMade = false, initialCount = 0, onToggle }) => {
  const [hasMade, setHasMade] = useState(initialMade);
  const [madeCount, setMadeCount] = useState(initialCount);
  const [loading, setLoading] = useState(false);

  const handleToggle = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert('Jelentkezz be, hogy megjelölhesd elkészítettként!');
      return;
    }

    setLoading(true);
    try {
      const response = await recipes.toggleMade(recipeId);
      setHasMade(response.data.hasMade);
      setMadeCount(response.data.madeCount);
      if (onToggle) onToggle(response.data);
    } catch (error) {
      console.error('Toggle made error:', error);
      alert('Hiba történt a megjelölés során');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className={`made-btn ${hasMade ? 'has-made' : ''}`}
      title={hasMade ? 'Elkészítettem ezt a receptet' : 'Megjelölés elkészítettként'}
    >
      <span className="made-icon">👨‍🍳</span>
      <span className="made-text">Megcsináltam</span>
      {madeCount > 0 && (
        <span className="made-count">{madeCount}</span>
      )}
    </button>
  );
};

export default MadeButton;
